import { Select, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import useAxios from "../../../hooks/useAxios";

const { Option } = Select;

const TinManageArrange = ({ tinData, tinOptions }) => {

  const tinType = tinData?.versantBasedTRF?.versantType
  const voice = tinData?.voiceCount || 0
  const written = tinData?.writtenCount || 0
  const count = tinType === 'both' ? voice + written : tinType === 'voice' ? voice : written

  return (
    <div className="flex flex-col">
      <div>
        <label className="">TIN</label>{" "}
        <span className="italic font-semibold text-[12px] text-[#227fe4]">
          (Available TINs: {count})
        </span>
      </div>
      <div>
        <Select
          showSearch
          className="w-100 p-0 outline-none bg-white"
          placeholder="Select Tin Type"
          disabled={tinOptions}
          value={tinOptions || null}
          optionFilterProp="children"
          filterOption={(input, option) => {
            return (
              option?.children?.toLowerCase().indexOf(input.toLowerCase()) >=
                0 ||
              option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
        >
          <Option value={"voice"}>Voice</Option>
          <Option value={"written"}>Written</Option>
          <Option value={"both"}>Both</Option>
        </Select>
      </div>
    </div>
  );
};

export default TinManageArrange;
